import 'ui-core/components/refine-search/js/refine-search';

const refine = UX.refine;

refine.click.toggleSearchBlock = () => {
    const tabs = document.querySelectorAll('.search-result__meta .advancedSearch__tabs');
    refine.ctrls.forEach(ctrl => {
        ctrl.addEventListener('click', function (e) {
            e.preventDefault();
            ctrl.classList.toggle('js--open');
            ctrl.setAttribute('aria-expanded', ctrl.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
            $(tabs).slideToggle();
        });
    });
};

refine.on.viewPortListener = function () {
    $(document).on(refine.vPort + '-on', function () {
        refine.isMobile = true;
    });

    $(document).on(refine.vPort + '-off', function () {
        refine.isMobile = false;
    });
};
